import BaseEnumType from "../../common/base-enum-type";

const RushType = Object.freeze({
    LEFT: new BaseEnumType("L", "Left"),
    RIGHT: new BaseEnumType("R", "Right"),
    MIDDLE: new BaseEnumType("M", "Middle"),
    LEFT_END: new BaseEnumType("LE", "Left End"),
    LEFT_GUARD: new BaseEnumType("LG", "Left Guard"),
    LEFT_TACKLE: new BaseEnumType("LT", "Left Tackle"),
    UP_MIDDLE: new BaseEnumType("UM", "Up Middle"),
    RIGHT_END: new BaseEnumType("RE", "Right End"),
    RIGHT_GUARD: new BaseEnumType("RG", "Right Guard"),
    RIGHT_TACKLE: new BaseEnumType("RT", "Right Tackle"),
    SKIP: new BaseEnumType("SKIP", "Skip")
});

export default RushType;
